// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nacli: PokeData = {
  "id": 932,
  "name": "nacli",
  "height": 4,
  "weight": 160,
  "base_experience": 56,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "rock-throw",
    "earthquake",
    "recover",
    "harden",
    "rock-slide",
    "iron-defense",
    "mud-shot",
    "rock-polish",
    "stone-edge",
    "stealth-rock",
    "smack-down",
    "heavy-slam"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "rock-throw",
    "earthquake",
    "rock-slide",
    "mud-shot",
    "stealth-rock",
    "power-siphon",
    "stone-crush",
    "boulder_bash",
    "rock-blast",
    "rock-tomb",
    "seismic-toss"
  ],
  "evolution_chain": {
    "id": 489,
    "item": null,
    "species": [
      {
        "name": "nacli",
        "order": 963,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "naclstack",
        "order": 964,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 932,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "garganacl",
        "order": 965,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 933,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 25,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
